import { useEffect } from 'react'
import useHttp from '@/shared/hooks/useHttp'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'
import {
  selectOrganizationsRoutes,
  selectOrganizationsSelectedProvider,
} from '@/containers/OrganizationsManagement/organizationsManagementSelectors'
import { setProvider } from '@/containers/OrganizationsManagement/organizationsManagementSlice'
import { useNavigate } from 'react-router'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { organizationsManagementActions } from '@/containers/OrganizationsManagement/organizationsManagementSagas'

const useSaveOrganization = (saveFn, id) => {
  const { country, loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const showNotification = useSnackbarNotification()
  const { enqueue } = useSnackbar()
  const { getConfig, sendRequest } = useHttp()
  const providerRoutes = useSelector(selectOrganizationsRoutes)
  const selectedProvider = useSelector(selectOrganizationsSelectedProvider)
  const { t } = useTranslation()
  const { type } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const isEditMode = !!id

  const finishSave = () => {
    showNotification({ type: SNACKBAR_TYPES.SUCCESS, message: t('organizationManagement:saved') })
    navigate('/' + type + '/organisations/provider')
  }

  const saveOptInSmsText = () =>
    dispatch({ type: organizationsManagementActions.SAVE_OPT_IN_SMS_TEXT, enqueue, onSuccess: finishSave })

  const saveProvider = () => {
    const url = isEditMode
      ? providerRoutes.update.replace('*', id) + '?lang=' + country
      : providerRoutes.store + '?lang=' + country
    const config = isEditMode ? getConfig('PUT') : getConfig('POST')

    saveFn(selectedProvider, dispatch, url, config, sendRequest, {
      onSuccess: isEditMode && selectedProvider.opt_in_active === true ? saveOptInSmsText : finishSave,
    })
  }

  useEffect(() => {
    if (!isEditMode) {
      dispatch(setProvider({}))
    }
  }, [])

  return { saveProvider, t, selectedProvider }
}

export default useSaveOrganization
